var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Dialog } from '../dialog';
import { drawerStyle } from './styles';
function DrawerInternal(_a) {
    var { 'aria-label': ariaLabel, children, closeButtonOverride, isOpen, onClose, placement = 'left', size = 'medium' } = _a, restProps = __rest(_a, ['aria-label', "children", "closeButtonOverride", "isOpen", "onClose", "placement", "size"]);
    return (_jsx(Dialog, Object.assign({ css: drawerStyle({ isVisible: isOpen, placement }) }, Object.assign({ 'aria-label': ariaLabel, closeButtonOverride,
        isOpen,
        onClose,
        size }, restProps), { children: children })));
}
export default DrawerInternal;
